// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-ac555f04] {\n  font-size: 1.9rem;\n  font-weight: bold;\n  line-height: 1.3;\n}\n.mt-10vh[data-v-ac555f04] {\n  margin-top: 10vh;\n}\n.mt-7vh[data-v-ac555f04] {\n  margin-top: 7vh;\n}", ""]);
// Exports
module.exports = exports;
